<template>
    <div class="main d-flex justify-content-center align-items-center flex-column">
        <div class="container shadow " v-if="!submit">
            <Stepper :currentForm="formStage" />
            <form ref="form" class="row g-3 my-5">
                <div class="personal-info text-start row d-flex justify-content-around " v-if="formStage1">
                    <div class="col-md-6 ">
                        <label for="Firstname" class="form-label">Ecological Zone</label>
                        <select class="form-select form-select-sm " aria-label="Default select example"
                            v-model="questionnaire.zone">
                            <option value="default" disabled selected>Open this select menu</option>
                            <option value="3">Northern Belt</option>
                            <option value="2">Middle Belt</option>
                            <option value="1">Southern Belt</option>
                        </select>
                    </div>


                    <div class="col-12 mt-4 d-flex justify-content-between">

                        <button class="btn btn-sm rounded-pill prev px-5  float-end mx-2"
                            @click="previous">prev</button>
                        <button class="btn btn-sm rounded-pill next px-5 float-end" @click="next"
                            :disabled="!questionnaire.zone || questionnaire.zone === 'default'">
                            next
                        </button>
                    </div>
                </div>
                <div class="row d-flex justify-content-center gap-4 text-start" v-if="formStage2">
                    <div class="col-md-4 smart_col_wrapper">
                        <input type="checkbox" id="smart-check-1" class="smart_check" value="productivity"
                            v-model="questionnaire.goals" />
                        <label for="smart-check-1" class="smart_col">
                            <div class="question">
                                I want to boost my crop yields and get more from my land by using improved seeds, better
                                soil management, and modern farming techniques.
                                <ol>
                                    <li>Use of high-yielding, early-maturing, and drought-tolerant varieties</li>
                                    <li>Improved land prep and inorganic fertilizers</li>
                                    <li>Integrated pest and disease management</li>
                                </ol>
                            </div>
                            <div class="feedback_label text-center">
                                <i class="bi bi-check-circle-fill me-2"></i>Low greenhouse gas emissions
                            </div>
                        </label>
                    </div>
                    <div class="col-md-4 smart_col_wrapper">
                        <input type="checkbox" id="smart-check-2" class="smart_check" value="mitigation"
                            v-model="questionnaire.goals" />
                        <label for="smart-check-2" class="smart_col">
                            <div class="question">
                                I want to farm in a way that protects the environment and reduces harmful emissions by
                                integrating trees, improving water use, and using sustainable inputs <ol>
                                    <li>Use of organic fertilizers, agroforestry, circular bioeconomy</li>
                                    <li>Reduced use of harmful pesticides</li>
                                    <li>Emphasis on bioproducts and reforestation</li>
                                </ol>
                            </div>
                            <div class="feedback_label text-center">
                                <i class="bi bi-check-circle-fill me-2"></i>Low greenhouse gas emissions
                            </div>
                        </label>
                    </div>
                    <div class="col-md-4 smart_col_wrapper">
                        <input type="checkbox" id="smart-check-3" class="smart_check" value="adaptation"
                            v-model="questionnaire.goals" />
                        <label for="smart-check-3" class="smart_col">
                            <div class="question">
                                I want my farm to withstand droughts, floods, and unpredictable weather by using
                                climate-resilient crops and better managing water and soil <ol>
                                    <li>Use of climate information services</li>
                                    <li>Drought-tolerant varieties, water-efficient irrigation</li>
                                    <li>Diversification with resilient livestock or crop varieties</li>
                                    <li>Knowledge systems and advisories</li>
                                </ol>
                            </div>
                            <div class="feedback_label text-center">
                                <i class="bi bi-check-circle-fill me-2"></i>Low greenhouse gas emissions
                            </div>
                        </label>
                    </div>
                    <div class="col-12 mt-4 d-flex justify-content-between">
                        <button class="btn btn-sm rounded-pill prev px-5  float-end mx-2"
                            @click="previous">prev</button>
                        <button class="btn btn-sm rounded-pill next px-5 float-end" @click="next"
                            :disabled="questionnaire.goals.length === 0">
                            next
                        </button>
                    </div>
                </div>
                <div class="row d-flex justify-content-center gap-4 text-start" v-if="formStage3">
                    <div class="col-md-4 invest_col_wrapper">
                        <input type="radio" name="invest" id="invest-check-1" class="invest_check" value="1"
                            v-model="questionnaire.investment" />
                        <label for="invest-check-1" class="invest_col">
                            <div class="question fs-6">
                                💸 Low Investment
                            </div>
                            <div class="invest_feedback_label text-start">
                                I’m working with limited resources, so I want simple and affordable practices that I can
                                implement right away without needing heavy equipment or advanced tools.
                                <ol>
                                    <li>Focus on low-cost options</li>
                                    <li>Excludes mechanization, irrigation, and inorganic fertilizers</li>
                                    <li>Emphasis on basic CSA practices like smart seed varieties, organic inputs, and
                                        basic soil management</li>
                                </ol>
                            </div>
                        </label>
                    </div>
                    <div class="col-md-4 invest_col_wrapper">
                        <input type="radio" name="invest" id="invest-check-2" class="invest_check" value="2"
                            v-model="questionnaire.investment" />
                        <label for="invest-check-2" class="invest_col">
                            <div class="question fs-6">
                                ⚖️ Intermediate Investment
                            </div>
                            <div class="invest_feedback_label text-start">
                                I can invest a little more to improve my farming, but I still need to avoid high-cost
                                solutions like irrigation or livestock diversification.
                                <ol>
                                    <li>Introduces inorganic fertilizers, improved land prep</li>
                                    <li>Still avoids livestock diversification and irrigation</li>
                                    <li>More enhanced than low but not fully diversified or mechanized</li>
                                </ol>
                            </div>
                        </label>
                    </div>
                    <div class="col-md-4 invest_col_wrapper">
                        <input type="radio" name="invest" id="invest-check-3" class="invest_check" value="3"
                            v-model="questionnaire.investment" />
                        <label for="invest-check-3" class="invest_col">
                            <div class="question fs-6">
                                💼 Medium Investment
                            </div>
                            <div class="invest_feedback_label text-start">
                                I’m ready to scale up my farm with some advanced techniques and inputs, even if it
                                requires moderate investment in tools or livestock.
                                <ol>
                                    <li>Includes livestock diversification</li>
                                    <li>Uses CIS, inorganic fertilizers, and advanced soil management</li>
                                    <li>Still excludes full mechanization or high-end irrigation systems</li>
                                </ol>
                            </div>
                        </label>
                    </div>
                    <div class="col-md-4 invest_col_wrapper">
                        <input type="radio" name="invest" id="invest-check-4" class="invest_check" value="4"
                            v-model="questionnaire.investment" />
                        <label for="invest-check-4" class="invest_col">
                            <div class="question fs-6">
                                🏗️ Full Investment
                            </div>
                            <div class="invest_feedback_label text-start">
                                I’m all in. I want to invest in everything I need—irrigation, mechanization, and
                                advanced technologies—to fully optimize my farm.
                                <ol>
                                    <li>Includes everything: irrigation, mechanization, agroforestry, and all inputs
                                    </li>
                                    <li>Targets triple-win outcomes (productivity, mitigation, adoptiontion)</li>
                                </ol>
                            </div>
                        </label>
                    </div>
                    <div class="col-12 mt-4">
                        <div class="mt-2 d-flex justify-content-between">   
                            <button class="btn btn-sm  px-5 prev rounded-pill float-end mx-2"
                                @click="previous">previous</button>

                            <div>
                                <p class="text-success fs-6 float-start mx-auto" v-show="responseMsg">Your process was
                                    Successful</p>
                                <p class="text-danger fs-6 float-start mx-auto" v-show="errorMsg">{{ error }}</p>
                            </div>

                            <button class="btn btn-sm px-5 next rounded-pill float-end"
                                @click.prevent="submitQuestionnaire" :disabled="!questionnaire.investment">
                                submit
                            </button>
                        </div>
                    </div>
                </div>

            </form>
        </div>

        <div class="container d-flex justify-content-center my-5" v-if="submit">
            <div class="card border-0 mb-3 shadow-lg py-4" style="max-width: 25rem;">
                <div class="card-body">
                    <i class="bi bi-award-fill fs-1"></i>
                    <h5 class="card-title fw-bold">Questionnaire Complete</h5>
                    <p class="card-text">You are from our {{ bundle.ecoZone.zone }} Zone with {{ bundle['investment _level'].level
                    }} investment and goals: {{ questionnaire.goals.join(', ') }}.</p>
                </div>
                <div class="card-foote border-0r bg-transparent ">
                    <button class="btn btn-sm btn-warning mx-1" @click="submit = false"><i
                            class="fa-solid fa-pen-to-square"></i></button>
                    <p v-if="!bundleId" class="text-muted fst-italic" style="font-size:12px">No Bundle Found</p>
                    <router-link v-else class="btn btn-sm btn-success w-75"
                        :to="{ name: 'bundles', query: { id: bundleId } }">View Bundle</router-link>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import axios from 'axios'
import Stepper from '../components/stepbar.vue'
export default {
    components: {
        Stepper
    },
    emits: [
        'progress',
        'borderstatus'
    ],
    props: [
        'dataToEdit'
    ],
    data() {
        return {
            questionnaire: {
                zone: 'default',
                investment: null,
                goals: []
            },
            bundle:null,
            bundleId: null,
            errorMsg: false,
            error: null,
            responseMsg: false,
            submit: false,
            progress: 0,
            formStage: 1,
            formStage1: false,
            formStage2: false,
            formStage3: false,
        };
    },
    mounted() {
        this.formStage1 = true;
    },
    created() {
    },
    watch: {
    },
    methods: {

        next(e) {
            e.preventDefault();
            this.formStage++;
            if (typeof eval(`this.formStage${this.formStage}`) !== "undefined") {
                this.formStage1 = false;
                this.formStage2 = false;
                eval(`this.formStage${this.formStage} = true`);
                this.$emit("progress", this.formStage);
            } else {
                this.formStage--;
            }
        },
        previous(e) {
            e.preventDefault();
            if (this.formStage > 1) {
                this.formStage--;
                if (typeof eval(`this.formStage${this.formStage}`) !== "undefined") {
                    this.formStage1 = false;
                    this.formStage2 = false;
                    this.formStage3 = false;
                    // this.formStage4 = false;
                    // this.formStage5 = false;
                    eval(`this.formStage${this.formStage} = true`);
                    this.$emit("progress", this.formStage);
                }
            }
        },
        submitQuestionnaire() {
            try {
                const queryParams = new URLSearchParams();

                if (this.questionnaire.zone) queryParams.append('ecoZoneId', this.questionnaire.zone);
                if (this.questionnaire.investment) queryParams.append('investmentLevelId', this.questionnaire.investment);

                if (Array.isArray(this.questionnaire.goals)) {
                    queryParams.append('productivity', this.questionnaire.goals.includes('productivity') ? true : false);
                    queryParams.append('mitigation', this.questionnaire.goals.includes('mitigation') ? true : false);
                    queryParams.append('adaptation', this.questionnaire.goals.includes('adaptation') ? true : false);
                } else {
                    queryParams.append('productivity', false);
                    queryParams.append('mitigation', false);
                    queryParams.append('adaptation', false);
                }

                axios.get(`https://aghub.miphost.com/api/bundler/bundle?${queryParams.toString()}`
                )
                    .then(response => {
                        this.bundle = response.data
                        this.bundleId = response.data.id
                        this.submit = true;
                        this.responseMsg = true;
                        setTimeout(() => {
                            this.responseMsg = false;
                        }, 5000);
                    })
                    .catch(error => {
                        console.log('Error fetching bundle:', error);
                        // this.error = error.response?.data?.message || 'Something went wrong';
                        // this.errorMsg = true;
                    });

            } catch (err) {
                console.error('Unexpected error:', err);
            }
        }


    },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.7.2/font/bootstrap-icons.css");

.input-group-text {
    cursor: pointer;
}

.main {
    height: 80vh;
}

ol {
    text-align: start;
}

.invest_col>.question {
    font-size: 1.2rem;
    font-weight: 500;
    color: #306102;
}

/* Hide the checkbox */
.smart_check {
    display: none;
}

/* Style the clickable area */
.smart_col {
    display: block;
    padding: 20px;
    background: #ce9d9d;
    border-radius: 8px;
    cursor: pointer;
    color: #000000;
    transition: background 0.3s ease;
    border: 2px solid transparent;
}

/* Hidden feedback label by default */
.feedback_label {
    margin-top: 10px;
    display: none;
    font-weight: bold;
}

/* When checked, highlight and show label */
.smart_check:checked+.smart_col {
    background: #eafff6;
    border-color: #0f5132;
}

/* Show feedback only when checked */
.smart_check:checked+.smart_col .feedback_label {
    display: block;
    color: #0f5132;
}

.smart_col:hover {
    border: 1px solid #306102 !important;
    border-radius: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    transition: 0.3s;
    cursor: pointer;
}







/* Hide the checkbox */
.invest_check {
    display: none;
}

/* Style the clickable area */
.invest_col {
    display: block;
    padding: 20px;
    background: #ce9d9d;
    border-radius: 8px;
    cursor: pointer;
    color: #000000;
    transition: background 0.3s ease;
    border: 2px solid transparent;
}

/* Hidden feedback label by default */
.invest_feedback_label {
    margin-top: 10px;
    display: none;
}

/* When checked, highlight and show label */
.invest_check:checked+.invest_col {
    background: #eafff6;
    border-color: #0f5132;
}

/* Show feedback only when checked */
.invest_check:checked+.invest_col .invest_feedback_label {
    display: block;
}

.invest_col:hover {
    border: 1px solid #306102 !important;
    border-radius: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    transition: 0.3s;
    cursor: pointer;
}

label {
    font-size: smaller;
}

.cursor {
    cursor: pointer;
}

.container {
    background: #d5b8b8;
    border-radius: 10px;
    padding-block: 2rem;
}

option {
    font-weight: 100;
    font-family: 'Raleway', sans-serif;
}

.prev {
    background-color: #8c8c8c;
    color: #fff
}

.prev:hover {
    background-color: #e6b600 !important;
    color: #fff
}

.next {
    background-color: #306102;
    color: #fff
}

.next:hover {
    background-color: #e6b600 !important;
    color: #fff
}

img {
    width: 100%;
    /* height: 4.5in; */
    object-fit: cover;
    transition: font-size 0.25s linear;
    -o-transition: font-size 0.25s linear;
    -moz-transition: font-size 0.25s linear;
    -webkit-transition: font-size 0.25s linear;
}

.form-select,
.form-control:focus {
    border-color: #c05b5b2a;
    outline: 0;
    background: rgba(147, 104, 104, 0.359);
    color: #000000;
    box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 0%);
}

option {
    font-weight: 100;
    font-family: 'Raleway', sans-serif;
}

for .link-btn {
    color: #fff !important;
    background-color: #cdcdcdb0 !important;
    border-color: #bababa !important;
}

.link-btn:hover {
    color: #fff !important;
    background-color: #b5b5b5 !important;
    border-color: #878787 !important;
}

.bi-x-circle {
    transition: transform .2s;
    /* Animation */
    display: inherit;
    margin-bottom: 0px;
}

.bi-x-circle:hover {
    color: red !important;
    transform: scale(1.5);
    /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.card:hover {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.input-group-text:hover {
    opacity: .9;
}
</style>